import React, { useState } from 'react';
import TextEditor from './TextEditor';
import MarkdownLatexRenderer from "./MarkdownLatexRenderer";
import 'react-quill/dist/quill.snow.css';
import './App.css';
import './index.css';

function App() {
    const [content, setContent] = useState('');

    return (
        <div className="App">
            <header className={"App-header"}>
                <h1>MarkTeX</h1>
                <p className={"header-blurb"}>A rich markdown editor with additional features and LaTeX support.</p>
            </header>
            <div className="small-screen-message">
                Please use a larger screen for the best experience.
            </div>
            <div className="editor-container">
                <div className="editor">
                    <TextEditor onChange={setContent}/>
                </div>
                <div className="preview">
                    <MarkdownLatexRenderer content={content} useLatinModernFont={true}/>
                </div>
            </div>
        </div>
    );
}

export default App;